import React from 'react';
import { useMediaQuery, Button, Text} from '@chakra-ui/react';
function OrderDateSelector({ selectedDate, appSettings, isAdmin, setShowModalSelectDate, setShowModalPriorityAccess, formatDate, formatDateWithTime, pranzoCena }) {
  const [isMobile] = useMediaQuery('(max-width: 600px)');
  if (!selectedDate) return null;
  return (
    <div style={{ marginBottom: 20 }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          border: '1px solid grey',
          borderRadius: 20,
          padding: 16,
          margin: '20px 0',
          flexWrap: 'wrap',
          gap: 16,
        }}
      >
        {/* <span style={{ fontSize: 26, color: 'gold', fontWeight: 600, textAlign: 'center' }}>
          Ordine per <br />
          {appSettings.showLunchDinner
            ? `${formatDate(selectedDate)} (${pranzoCena(selectedDate)})`
            : formatDateWithTime(selectedDate)}
        </span> */}
        <Text
              fontSize='xl'
              color={'gold'}
              fontWeight={600}
              textAlign={isMobile ? 'center' : 'left'}
            >
              Ordine per <br />
              {appSettings.showLunchDinner
                ? `${formatDate(selectedDate)} (${pranzoCena(selectedDate)})`
                : formatDateWithTime(selectedDate)}
            </Text>
        <Button
          onClick={() => {
            setShowModalSelectDate(true);
            if (appSettings.appStatus === 'priority' && !isAdmin) {
              setShowModalPriorityAccess(true);
            }
          }}
        >
          Cambia Data
        </Button>
      </div>
    </div>
  );
}

export default OrderDateSelector; 